/*
  SOLEIL hero image fade — LCP-safe overlay reveal.

  GRACEFUL DEGRADATION (Motion Stack §3):
    - Stack present (window.SoleilMotion): GSAP animates the overlay opacity
      via a CSS custom property (GSAP can't target the ::before pseudo-element):
          [data-soleil-hero]::before { opacity: var(--soleil-hero-overlay, 1); }
    - Stack absent: the original rAF + `.is-loaded` class-toggle path runs (CSS
      transition on the overlay), exactly as before.

  LCP-safety is identical in both paths: the <img> renders at opacity:1 from
  frame one; only the ::before overlay animates. Stays a classic `defer` script
  so non-opted-in projects keep working without an importmap. Controller loads
  first (scripts.liquid order) so window.SoleilMotion is set when this runs.
*/
(function () {
  'use strict';

  var sections = document.querySelectorAll('[data-soleil-hero]');
  if (!sections.length) return;

  var Motion = window.SoleilMotion;
  var useGsap = !!(Motion && !Motion.reduced);

  function reveal(section) {
    if (useGsap) {
      Motion.gsap.to(section, {
        '--soleil-hero-overlay': 0,
        duration: 0.6,
        ease: 'power2.out',
        onStart: function () { section.classList.add('is-loaded'); }
      });
    } else {
      requestAnimationFrame(function () { section.classList.add('is-loaded'); });
    }
  }

  sections.forEach(function (section) {
    var imgs = section.querySelectorAll('img');
    if (!imgs.length) {
      reveal(section);
      return;
    }
    var revealed = false;
    function tryReveal() {
      if (revealed) return;
      revealed = true;
      reveal(section);
    }
    imgs.forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) {
        tryReveal();
      } else {
        img.addEventListener('load', tryReveal, { once: true });
        img.addEventListener('error', tryReveal, { once: true });
      }
    });
  });
}());
